import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { TrendingUp, PieChart, Building, Briefcase, MoreHorizontal } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { portfolioProducts } from '../mock';

const PortfolioManagement = () => {
  const iconMap = {
    "PMS": TrendingUp,
    "AIF": PieChart,
    "Mutual Funds": Building,
    "Unlisted Shares": Briefcase,
    "Others": MoreHorizontal
  };

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Page Header */}
      <section className="pt-24 pb-8 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 via-white to-blue-50/30">
        <div className="container mx-auto">
          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 text-center">
            <h1 className="text-3xl sm:text-4xl font-bold text-[#DC143C] mb-4">
              Portfolio Management
            </h1>
            <p className="text-base text-gray-600">
              Expert investment management services designed to grow and protect your wealth
            </p>
          </div>
        </div>
      </section>

      {/* Portfolio Cards */}
      <section className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {portfolioProducts.map((product) => {
              const IconComponent = iconMap[product.name] || TrendingUp;
              return (
                <Link key={product.id} to={product.path}>
                  <Card className="group hover:shadow-xl transition-all duration-300 border-2 border-gray-200 hover:border-[#2C3E50] cursor-pointer h-full">
                    <CardHeader className="text-center">
                      <div className="w-16 h-16 bg-blue-50 rounded-xl flex items-center justify-center mb-4 mx-auto group-hover:bg-[#2C3E50] transition-colors duration-300">
                        <IconComponent className="w-8 h-8 text-[#2C3E50] group-hover:text-white transition-colors duration-300" />
                      </div>
                      <CardTitle className="text-xl font-bold text-gray-900 group-hover:text-[#2C3E50] transition-colors mb-2">
                        {product.name}
                      </CardTitle>
                      {product.fullName && (
                        <CardDescription className="text-sm text-gray-600">
                          {product.fullName}
                        </CardDescription>
                      )}
                    </CardHeader>
                  </Card>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PortfolioManagement;